export default "__VITE_ASSET__Dq4t84T6__"